import axios from "axios";
import { useQuery } from "react-query";
import { DataMappingBatch, MappingType, StatusBucket } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/ProducerCode";

interface DataMappingBatchResponse {
  batchId: number;
  mappingType: MappingType;
  createdDate: string;
  createdBy: string;
  total: number;
  succeeded: number;
  corrected: number;
  skipped: number;
  failed: number;
}

const getStatusBucket = (
  mappingType: MappingType,
  succeeded: number,
  corrected: number,
  skipped: number,
  failed: number,
): StatusBucket => {
  const isCDRCStatusReconciliation =
    mappingType === "CDRC Status Reconciliation";

  if (isCDRCStatusReconciliation) {
    const nonFailed = corrected + skipped;

    if (nonFailed > 0 && failed > 0) {
      return "Partial";
    }

    if (failed > 0) {
      return "Failed";
    }

    return "Succeeded";
  }

  if (succeeded > 0 && failed > 0) {
    return "Partial";
  }

  if (failed > 0) {
    return "Failed";
  }

  return "Succeeded";
};

export const getRecentMappingActivities = async (
  top = 6,
): Promise<DataMappingBatch[]> => {
  const { data } = await axios.get<DataMappingBatchResponse[]>(
    `${API_BASE_URL}/RecentActivities/Batches`,
    {
      params: {
        top,
      },
    },
  );

  return data.map((row) => ({
    ...row,

    corrected: row.corrected ?? 0,
    skipped: row.skipped ?? 0,
    succeeded: row.succeeded ?? 0,
    failed: row.failed ?? 0,

    bucket: getStatusBucket(
      row.mappingType,
      row.succeeded ?? 0,
      row.corrected ?? 0,
      row.skipped ?? 0,
      row.failed ?? 0,
    ),
  }));
};

export const useRecentMappingActivities = (top = 6) => {
  return useQuery(
    ["RecentMappingActivities", top],
    () => getRecentMappingActivities(top),
    {
      refetchOnWindowFocus: false,
    },
  );
};
